import MuiMenuItem from "@material-ui/core/MenuItem";
import { createStyles, withStyles } from "@material-ui/core/styles";

import { RelodeTheme } from "../";

const styles = (theme: RelodeTheme) =>
    createStyles({
        root: {
            backgroundColor: theme.palette.background.paper,

            "& a, & span": {
                display: "block",
                textDecoration: "none",
                color: "inherit",
            },

            "&:hover": {
                backgroundColor: theme.palette.secondary.main,
            },
        },
    });

export const MenuItem = withStyles(styles, { withTheme: true })(MuiMenuItem);
